import { Dialog, DialogContent, Slide } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  SimpleDialogRoot: {
    zIndex: '1050 !important',
  },
  SimpleDialogContainer: {
    padding: 16,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  SimpleDialogPaper: {
    margin: 0,
    flex: '1 1 auto',
    height: '100%',
  },
  SimpleDialogPaperFullScreen: {
    borderRadius: '8px !important',
  },
  SimpleDialogPaperScrollPaper: {
    maxHeight: '100%',
  },
  SimpleDialogContentRoot: {
    padding: 0,
    margin: 0,
    '&:first-child': {
      paddingTop: 0,
    },
  },
  SimpleDialogPaperWidthSm: {
    maxWidth: 685,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const SimpleDialog = ({ fullScreen, open, onClose, maxWidth, paperClass, children, container }) => {
  const theme = useTheme();
  const mediaQuerySm = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <Dialog
      fullScreen={fullScreen || mediaQuerySm}
      classes={{
        root: classes.SimpleDialogRoot,
        container: clsx(classes.SimpleDialogContainer, container),
        paper: clsx(classes.SimpleDialogPaper, maxWidth, paperClass),
        paperFullScreen: classes.SimpleDialogPaperFullScreen,
        paperScrollPaper: classes.SimpleDialogPaperScrollPaper,
        paperWidthSm: !fullScreen ? classes.SimpleDialogPaperWidthSm : '',
      }}
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="simple-dialog"
      TransitionComponent={Transition}
    >
      <DialogContent classes={{ root: classes.SimpleDialogContentRoot }}>{children}</DialogContent>
    </Dialog>
  );
};

SimpleDialog.propTypes = {
  fullScreen: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  maxWidth: PropTypes.string,
  paperClass: PropTypes.string,
};

SimpleDialog.defaultProps = {
  fullScreen: false,
  open: false,
  onClose: () => {},
  maxWidth: '',
  paperClass: '',
};

export default SimpleDialog;
